// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3GhjL","rootSmall":"AddTileButton_rootSmall__2RsA7"};